import { activityTypes } from 'constants/activities';
import networkAdapter from '../adapters/network';

export const fetchActivitiesForFieldUuids = ({ activityType, fieldUuids, userId }) => {
  const params = activityType ? `?activity-type=${activityType}` : '';
  const legacyOptions = {
    url: `/api/groot/v2/activities/fields/query${params}`,
    method: 'POST',
    body: JSON.stringify({
      'field-uuids': fieldUuids
    }),
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export type ActivityType = typeof activityTypes[keyof typeof activityTypes];
export interface ActivityParam {
  date: string;
  fieldUuid: string;
  season?: string | null;
  type: ActivityType;
  uuid: string;
}

export interface SendCreateNewActivitiesParams {
  activitiesParams: ActivityParam[];
  userId: string;
}

export interface NewActivitiesResponse { 
  activities: string[];
}

export const sendCreateNewActivities = ({
  activitiesParams,
  userId
}: SendCreateNewActivitiesParams): Promise<NewActivitiesResponse> => {
  const activities = activitiesParams.map(({ date, fieldUuid, season = null, type, uuid }) => ({
    type,
    date,
    enabled: true,
    'field-uuid': fieldUuid,
    'primary-rx': null,
    season,
    uuid
  }));

  const legacyOptions = {
    url: `/api/groot/v2/activities`,
    method: 'POST',
    body: JSON.stringify({ activities }),
    userId
  };

  return networkAdapter({
    legacyOptions
  });
};

interface UpdateExistingActivityParams {
  uuid: string;
  date?: string;
  fieldUuid: string;
  primary?: boolean;
  season: string;
  type: string;
  userId: string;
}

interface UpdateActivityResponse extends NewActivitiesResponse {}

export const sendUpdateExistingActivity = ({
  uuid,
  date,
  fieldUuid,
  primary,
  season,
  type,
  userId
}: UpdateExistingActivityParams): Promise<UpdateActivityResponse> => {
  const legacyOptions = {
    url: `/api/groot/v2/activities`,
    method: 'PUT',
    body: JSON.stringify({
      'activities': [
        {
          'type': type,
          'date': date,
          'enabled': true,
          'field-uuid': fieldUuid,
          'primary-rx': primary,
          'season': season,
          'uuid': uuid
        }
      ]
    }),
    userId
  };

  return networkAdapter({
    legacyOptions
  });
};
